import { TextareaAutosize } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React, { Fragment, useMemo } from 'react';

const EnhancedTextarea = ({
  errorText,
  textareaStyle,
  color,
  borderColor,
  ...props
}) => {
  const useStyles = makeStyles(theme => ({
    error: {
      marginTop: 10,
      fontSize: 12,
      lineHeight: '12px',
    },
    textarea: {
      marginTop: 0,
      lineHeight: 'normal',
      padding: 8,
      width: '100%',
      borderRadius: 1,
      border: `1px solid ${
        borderColor || theme.palette.text.primary
      }`,
      color,
    },
  }));

  const classes = useStyles();

  return (
    <Fragment>
      <TextareaAutosize
        minRows={3}
        maxRows={6}
        {...props}
        style={useMemo(
          () => ({
            ...textareaStyle,
          }),
          [textareaStyle],
        )}
        className={classes.textarea}
      />
      {errorText && <div className={classes.error}>{errorText}</div>}
    </Fragment>
  );
};

EnhancedTextarea.propTypes = {
  ...TextareaAutosize.propTypes,
  errorText: PropTypes.string,
  textareaStyle: PropTypes.object,
};

export default EnhancedTextarea;
